import { render, staticRenderFns } from "./singleReportingView.vue?vue&type=template&id=5287bcbc&scoped=true&"
import script from "./singleReportingView.vue?vue&type=script&lang=js&"
export * from "./singleReportingView.vue?vue&type=script&lang=js&"
import style0 from "./singleReportingView.vue?vue&type=style&index=0&id=5287bcbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287bcbc",
  null
  
)

export default component.exports